// src/redux/baseQueryWithInterceptor.js
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import config from '../utils/config';
import Swal from 'sweetalert2';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: config.baseUrl,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("jwtToken");
    const hem = localStorage.getItem('hemAuth');
    if (token) headers.set("Authorization", `Bearer ${token}`);
    if (hem) headers.set("hemauth", hem);
    return headers;
  },
});

export const baseQueryWithInterceptor = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  // 🔐 Handle 401 - Session Expired
  if (result?.error?.status === 401) {
    const theme = localStorage.getItem('theme');
    Swal.fire({
      title: 'Redirecting...',
      html: 'You will be redirected to login in <b></b> seconds.',
      timer: 3000,
      timerProgressBar: true,
      didOpen: () => {
        const b = Swal.getHtmlContainer().querySelector('b');
        const timerInterval = setInterval(() => {
          b.textContent = Math.ceil(Swal.getTimerLeft() / 1000);
        }, 100);
        Swal.showLoading();
        Swal.willClose = () => clearInterval(timerInterval);
      },
    }).then(() => {
      localStorage.clear();
      localStorage.setItem('theme', theme);
      window.location.href = '/login';
    });
  }

  // 🔒 Handle 302 - 2FA Required
  if (result?.error?.status === 302) {
    const hem = result?.error?.data?.token;
    if (hem) {
      localStorage.setItem('hemAuth', hem);
      localStorage.setItem('pr','ga')
    }

    Swal.fire({
      title: '2FA Enabled',
      html: 'Redirecting to 2FA verification in <b></b> seconds.',
      timer: 3000,
      timerProgressBar: true,
      didOpen: () => {
        const b = Swal.getHtmlContainer().querySelector('b');
        const timerInterval = setInterval(() => {
          b.textContent = Math.ceil(Swal.getTimerLeft() / 1000);
        }, 100);
        Swal.showLoading();
        Swal.willClose = () => clearInterval(timerInterval);
      },
    }).then(() => {
      window.location.href = '/google-auth';
    });
  }

  return result;
};
